import { render } from "./logo_white.vue?vue&type=template&id=c97dd0be&scoped=true"
import script from "./logo_white.vue?vue&type=script&lang=js"
export * from "./logo_white.vue?vue&type=script&lang=js"

import "./logo_white.vue?vue&type=style&index=0&id=c97dd0be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c97dd0be"]])

export default __exports__